import { render, staticRenderFns } from "./QCReportPage.vue?vue&type=template&id=2ca5adb7&scoped=true&"
import script from "./QCReportPage.vue?vue&type=script&lang=js&"
export * from "./QCReportPage.vue?vue&type=script&lang=js&"
import style0 from "./QCReportPage.vue?vue&type=style&index=0&id=2ca5adb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5adb7",
  null
  
)

export default component.exports